import script from "./reservation.vue?vue&type=script&setup=true&lang=js"
export * from "./reservation.vue?vue&type=script&setup=true&lang=js"

import "./reservation.vue?vue&type=style&index=0&id=1117cb37&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1117cb37"]])

export default __exports__